<template>
    <div class="employee-training">
        <ul class="uk-tab" uk-switcher="">
            <li class="uk-active"><a href="#employee-training-current">Current</a></li>
            <li><a href="#employee-training-archive">Archive</a></li>
        </ul>
        <ul class="uk-switcher">
            <li class="uk-container uk-container-expand">
                <div v-for="training in trainings" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-right employee-training-row">
                    <div class="uk-width-4-5">
                        <input class="uk-input" disabled :value="trainingString(training)"  />
                        <span v-if="training.expires_soon" class="warning-icon"><i class="fas fa-exclamation-triangle"></i></span>
                        <div uk-form-custom>
                            <input :id="'training-upload-' + training.id" type="file" multiple @change="uploadTrainingFile($event, training)" />
                        </div>
                    </div>
                    <div class="uk-width-1-5 controls">
                        <a href="#" :uk-toggle="'target: #' + viewModalId" @click="activateViewModal(training.id)"><i class="fas fa-search"></i></a>
                        <a href="#" :uk-toggle="'target: #' + formModalId" @click="activateEditModal(training.id)"><i class="fas fa-edit"></i></a>
                        <label :for="'training-upload-' + training.id" class="upload-link"><i class="fas fa-upload"></i></label>
                        <a href="#" :uk-toggle="'target: #' + deleteModalId"  @click="activateDeleteModal(training.id)"><i class="fas fa-trash"></i></a>
                    </div>
                </div>
                <div class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
                    <a :uk-toggle="'target: #' + formModalId"><i class="fas fa-plus-circle"></i> Add Another Training</a>
                </div>
            </li>
            <li class="uk-container uk-container-expand">
                <div v-for="training in archives" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-right employee-training-row">
                    <div class="uk-width-4-5">
                        <input class="uk-input" disabled :value="trainingString(training)"  />
                        <div uk-form-custom>
                            <input :id="'training-upload-' + training.id" type="file" multiple @change="uploadTrainingFile($event, training)" />
                        </div>
                    </div>
                    <div class="uk-width-1-5 controls">
                        <a href="#" :uk-toggle="'target: #' + viewModalId" @click="activateViewModal(training.id)"><i class="fas fa-search"></i></a>
                        <a href="#" :uk-toggle="'target: #' + formModalId" @click="activateEditModal(training.id)"><i class="fas fa-edit"></i></a>
                        <label :for="'training-upload-' + training.id" class="upload-link"><i class="fas fa-upload"></i></label>
                        <a href="#" :uk-toggle="'target: #' + deleteModalId"  @click="activateDeleteModal(training.id)"><i class="fas fa-trash"></i></a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Moment from "moment";
    export default {
        name: "EmployeeTraining",

        props: {
            uid:Number,
            formModalId:String,
            formRef:String,
            viewModalId:String,
            viewRef:String,
            deleteModalId:String,
            deleteFormRef:String
        },

        data() {
            return {
                trainings:[],
                archives:[]
            };
        },
        mounted() {
            this.loadTrainings();
        },
        methods:{
            loadTrainings(){
                axios.get("/api/employee/get/" + this.uid + "/training/list")
                    .then((pack) => this.updateTrainings(pack));
                axios.get("/api/employee/get/" + this.uid + "/training/expired")
                    .then((pack) => this.updateArchives(pack));
            },
            startSearch(){//alias for other items that call this function
                this.loadTrainings();
            },
            updateTrainings(pack){
                this.trainings = pack.data.data;
            },
            updateArchives(pack){
                this.archives = pack.data.data;
            },
            activateEditModal(id){
                this.$root.$refs[this.formRef].loadForm(id);
            },
            activateViewModal(id){
                this.$root.$refs[this.viewRef].loadForm(id);
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            },
            uploadTrainingFile(event, training){
                let formData = new FormData();

                for(let i = 0; i < event.target.files.length;++i){
                    formData.append("file" + i, event.target.files[i]);
                }

                axios.post("/api/employee/"+this.uid+"/training-file/" + training.id, formData)
                    .then(() => this.loadTrainings());
            },
            formatDate(dateString){
                let date = new Moment(dateString);
                return date.format("MM/DD/YYYY");
            },
            trainingString(training){
                if(training.completed){
                    if(training.expiration){
                        return training.name + " • " + this.formatDate(training.completed) + " - " + this.formatDate(training.expiration);
                    } else {
                        return training.name + " • " + this.formatDate(training.completed);
                    }
                } else {
                    return training.name;
                }

            }
        }
    }
</script>

<style scoped>

</style>
